import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';
import './style.css';
import { Button } from 'antd';
import queryString from 'query-string';
import { Trans } from '@lingui/macro';

const Styled = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100%;

  .main-container {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 480px;
    height: 240px;

    .button-container {
      display: flex;
      flex: 3;
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
      margin-bottom: 10%;
      border-radius: 3px;

      .name {
        margin-bottom: 5%;
        font-size: 16px;
        font-weight: 600;
        color: white;
        text-align: center;
      }
    }

  }
`;

/**
 * Two ways to define:
 * - using location prop       - url string
 * - provide src and alt props - string
 * @param {*} param0
 * @returns
 */
function NoPreviewIframe({
    location,
    src,
    alt,
}) {
    const params = queryString.parse(location?.search);

    const { link, name } = params;

    return (
        <Styled className="iframe--no-preview">
            <div className="main-container">
                <div className="button-container">
                    <div className="name">{name || alt || 'Invalid File'}</div>
                    <a className="link" href={link ?? src} target="_blank" rel="noopener noreferrer">
                        <Button type="primary" className="flex1">
                            <Trans>Download</Trans>
                        </Button>
                    </a>
                </div>
            </div>
        </Styled>
    );

    // return (<iframe
    //     width="100%"
    //     height="100%"
    //     src={`/no-preview?link=${encodeURIComponent(urlNoPreview)}
    //     &name=${encodeURIComponent("noPreview")}`}
    //     frameBorder="0"
    //     allow="autoplay; encrypted-media"
    //     allowFullScreen="false"
    //     ref={frame => this.video = frame}
    //     className="video__iframe"
    // />)
}

export default connect()(NoPreviewIframe);
